export default __webpack_public_path__ + "876c61e928cb10fcc1f3f00eb02b1c99.png";